import React, { Component } from 'react';

class TagInputComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
              <input                  
                onChange={e => this.props.onTagNameChanged(e.target.value)}
                value={this.props.tag}
                placeholder="Type name here"
                className='tags-input sample-pack-input'
                type="text"/>
            </div>
        );
    }
}
                
export default TagInputComponent;
